export const FRAMEWORK = {
  name: "Summit Transformation Framework™",
  tagline: "A Practical System for Leading Organizational Transformation.",
  outcome: "Sustainable Transformation",
  phases: [
    {
      n: 1,
      title: "Define the Change",
      subtitle: "Create Clarity",
      description:
        "Establish a shared understanding of what is changing, why it matters, and what success looks like—so leaders and stakeholders work from the same definition from the start.",
    },
    {
      n: 2,
      title: "Assess Readiness",
      subtitle: "Understand Capacity",
      description:
        "Evaluate the organization's capacity to absorb change across leadership, culture, workforce capability, governance, and competing priorities.",
    },
    {
      n: 3,
      title: "Align Leadership",
      subtitle: "Build Commitment",
      description:
        "Secure visible sponsorship, resolve competing agendas, and equip leaders at every level to own their role in the transformation.",
    },
    {
      n: 4,
      title: "Engage Stakeholders",
      subtitle: "Drive Ownership",
      description:
        "Move people from awareness to ownership through structured engagement, two-way communication, and meaningful involvement in shaping the change.",
    },
    {
      n: 5,
      title: "Sustain Adoption",
      subtitle: "Deliver Lasting Results",
      description:
        "Reinforce new ways of working, measure adoption, and build the organizational capability to keep improving long after the initial effort.",
    },
  ],
};

export const DIMENSIONS = [
  {
    name: "Strategy",
    description: "Clear priorities and outcomes that connect AI to the mission and operating model.",
  },
  {
    name: "Leadership",
    description: "Executives and managers who sponsor, model, and make decisions about AI-enabled work.",
  },
  {
    name: "Governance",
    description: "Decision rights, policies, and responsible-use guardrails that build trust.",
  },
  {
    name: "People",
    description: "Workforce literacy, confidence, and the capacity to work differently.",
  },
  {
    name: "Adoption",
    description: "Engagement, reinforcement, and measurement that turn pilots into practice.",
  },
];
